module.exports = require("@material-ui/icons/Close");


//////////////////
// WEBPACK FOOTER
// external "@material-ui/icons/Close"
// module id = 300
// module chunks = 0